import { Columns, Row } from './types';
import { Header4, Paragraph } from '@ardoq/typography';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { Icon } from '@ardoq/icons';
import { StatusType } from '@ardoq/status-ui';
import { Island } from '@ardoq/page-layout';
import { FlexBox } from '@ardoq/layout';
import { type I18nLocale, t } from '@ardoq/i18n';

export function ExpandedRow({
  i18nLocale,
  row,
  columnHeadings,
  emptyLabel = t(i18nLocale, 'integrations:summaryMatrix.emptyLabel', 'Empty'),
}: {
  i18nLocale: I18nLocale;
  row: Row;
  columnHeadings: Columns['otherColumns'];
  emptyLabel?: string;
}) {
  return (
    <Container padding="large" gap="medium">
      {row.columns.map((column, index) => (
        <Island
          key={index}
          minWidth="unset"
          isScrollable
          bodySpacing="medium"
          header={
            <FlexBox align="center" gap="medium" padding="medium">
              <ColorfulIcon iconName={column.iconName} status={column.status} />
              <Header4>{columnHeadings[index]}</Header4>
            </FlexBox>
          }
        >
          {!column.affectedValues?.length && (
            <Paragraph variant="text1Italic">{emptyLabel}</Paragraph>
          )}

          {!!column.affectedValues?.length &&
            column.affectedValues.map(value => (
              <span key={value}>{value}</span>
            ))}
        </Island>
      ))}
    </Container>
  );
}

const Container = styled(FlexBox)`
  background-color: ${colors.grey50};
  > div {
    flex: 1;
    max-height: 300px;
  }
`;
const STATUS_COLORS = new Map<StatusType, string>([
  [StatusType.SUCCESS, colors.green600],
  [StatusType.INFO, colors.blue600],
  [StatusType.WARNING, colors.yellow700],
  [StatusType.ERROR, colors.red700],
]);

const ColorfulIcon = styled(Icon)<{ status: StatusType }>`
  color: ${({ status }) => {
    return STATUS_COLORS.get(status) || colors.grey500;
  }};
`;
